import PropTypes from 'prop-types';

const Icon = ({ base, detail, isActive }) => {
  const baseIconClass = isActive ? 'fa-solid' : 'fa-light';
  const detailIconClass = isActive ? 'fa-solid' : 'fa-regular';
  const { icon: baseIcon, activeClasses: baseActiveClasses } = base;
  const {
    positioning: detailPositioning,
    icon: detailIcon,
    activeClasses: detailActiveClasses
  } = detail;

  return (
    <span className={`fa-stack fa-1x mr-3`}>
      <i
        className={`fa-stack-2x group-hover:text-blue-600 transition-colors ${baseIcon} ${
          isActive
            ? baseActiveClasses || baseIconClass
            : [baseIconClass, 'text-black'].join(' ')
        }`}
      ></i>
      {detailPositioning ? (
        <i
          className={`fa-solid fa-circle fa-stack-1x ${
            isActive ? 'text-white' : 'text-gray-50'
          } ${detailPositioning}`}
        ></i>
      ) : null}
      {detailIcon ? (
      <i
        className={`fa-stack-1x group-hover:text-blue-600 transition-colors ${detailIconClass} ${detailIcon} ${
          isActive ? detailActiveClasses || '' : 'text-black'
        } ${detailPositioning || ''}`}
      ></i>
      ) : null}
    </span>
  );
};

Icon.propTypes = {
  base: PropTypes.object,
  detail: PropTypes.object,
  isActive: PropTypes.bool
};

export default Icon;
